import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from 'Actions/taskManage/interactivePath';
import tDetailActions from 'Actions/taskManage/detail';
import DetailDrawer from 'Components/detailDrawer';
import UnionComponent from 'Components/union/unionComponent';
import { Drawer, Row, Col, Table, Button, message } from "antd"
class InteractionDetails extends UnionComponent {
    state = {
        tableListLoading: false,
    }
    onPageChange = (page, pageSize) => {
        let { detailListParams } = this.props;
        let data = {
            ...detailListParams,
            pageNum: page,
            pageSize: pageSize,
        }
        this.props.actions.setState({
            key: "detailListParams",
            value: data
        })
        this.setTableListLoading();
        this.props.actions.getDetailList(data).finally(_ => {
            this.setTableListLoading();
        })
    }
    // 关闭通话详情抽屉
    closeDetailDrawer = () => {
        this.props.actions.setState({
            key: "taskDetail",
            value: {
                rowId: -1,
                show: false,
            }

        });
    };
    onShowSizeChange = (current, size) => {
        let { detailListParams } = this.props;
        let data = {
            ...detailListParams,
            pageNum: current,
            pageSize: size,
        }
        this.props.actions.setState({
            key: "detailListParams",
            value: data
        })
        this.setTableListLoading();
        this.props.actions.getDetailList(data).finally(_ => {
            this.setTableListLoading();
        })
    }
    showDetailDrawer = (record) => {
        const { detailActions } = this.props;
        this.props.actions.setState({
            key: "taskDetail.rowId", value: record.jobId,
        });
        this.props.actions.setState({
            key: "taskDetail", value: { show: this.props.taskDetail.show, rowId: record.jobId },
        });
        this.setTableListLoading();
        detailActions.getDetailDrawerData(record.jobId).then(res => {
            this.props.actions.setState({
                key: "taskDetail", value: { show: true, rowId: this.props.taskDetail.rowId },
            });
        }).finally(() => {
            this.setTableListLoading();
        });
    }

    export = () => {
        this.setTableListLoading();
        this.props.actions.interactDetailDownload(this.props.detailListParams).then(res => { // 接口请求
            let fileName;
            try {
                fileName = decodeURIComponent(res.payload.headers["content-disposition"].split(" ")[1].split("=")[1]);
            } catch {
                fileName = `${Date.now()}.${fileType == "excel" ? "xlsx" : "csv"}`
            }
            message.success("导出成功");
            let blob = new Blob([res.payload.data], { type: 'application/vnd.ms-excel' })
            let elink = document.createElement('a');
            elink.download = fileName // 下载文件名称
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            document.body.removeChild(elink) //下载完成移除元素
            window.URL.revokeObjectURL(elink) //释放掉blob对象
        }).finally(() => {
            this.setTableListLoading();
        });
    }

    render() {
        let { showDetail, colors } = this.props;
        const columns = [
            {
                title: '',
                className: "h_36",
                dataIndex: '',
                width: 30,
                align: "center",
                render: (text, record, index) => {
                    return (<div style={{ marginLeft: 10, width: 10, height: 10, borderRadius: "100%", background: colors[index] }}></div>)
                }
            },
            {
                title: '响应次数',
                className: "h_36",
                dataIndex: 'replyTimes',
            },
            {
                title: '通话量',
                className: "h_36",
                dataIndex: 'answerNum',
            },
            {
                title: '响应量',
                className: "h_36",
                dataIndex: 'replayNum',
            },
        ]
        const columns1 = [
            {
                title: '',
                className: "h_50",
                dataIndex: '',
                width: 15
            },
            {
                title: '序号',
                className: "h_50",
                dataIndex: '',
                width: 50,
                render: (text, record, index) => {
                    return (<div>{index + 1}</div>)
                }
            },
            {
                title: '呼叫标识',
                className: "h_50",
                dataIndex: 'jobId',
            },
            {
                title: 'CallID',
                className: "h_50",
                dataIndex: 'callId',
                render: (text, record, index) => {
                    return <span style={{ color: '#40aefc', cursor: 'pointer' }} onClick={() => this.showDetailDrawer(record)}>{text}</span>
                }
            },
            {
                title: '响应次数',
                className: "h_50",
                dataIndex: 'replyTimes',
            },
        ]
        let { detailCountList } = this.props;
        let totalNum = 0;
        detailCountList.forEach((item) => {
            totalNum += item.replayNum;
        })
        let data = detailCountList.map((item, index) => {
            return {
                value: item.replayNum,
                replyTimes: item.replyTimes,//响应次数
                answerNum: item.answerNum,//通话量
                name: '响应量',
                label: {
                    color: "#fff",
                },
                itemStyle: {
                    color: colors[index],
                    borderRadius: 30,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                tooltip: {
                    borderColor: colors[index],
                    borderWidth: 2,
                }
            }
        })
        this.props.echarts && this.props.echarts.setOption({
            title: {
                text: "总响应量",
                left: "center",
                top: "43%",
                textStyle: {
                    color: "#333333",
                    fontSize: 16,
                    align: "center"
                }
            },
            graphic: {
                type: "text",
                left: "center",
                top: "53%",
                style: {
                    text: totalNum,
                    textAlign: "center",
                    fill: "#333",
                    fontSize: 16,
                    fontWeight: 700
                }
            },
            tooltip: {
                trigger: 'item',
                backgroundColor: 'rgba(255,255,255,1)',
                textStyle: {
                    color: "#000"
                },
                position: function (point, params, dom, rect, size) {
                    //  size为当前窗口大小
                    if (point[0] < (size.viewSize[0] / 3)) {
                        return [point[0] - 100, point[1]]
                    } else if (point[0] < (2 * size.viewSize[0] / 3)) {
                        return [point[0] - 50, point[1]]
                    } else {
                        return [point[0] - 230, point[1]];
                    }
                },
                formatter: function (params) {
                    let circle = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:`;
                    const result = '<div style="font-size:12px"><span style="font-size:13px;font-weight:800">响应量分析</span><br/>' + circle + params.color + `"></span>` + `响应次数：${params.data.replyTimes}，通话量：${params.data.answerNum}，响应量：${params.value}` + "</div>";
                    return result;
                },
            },
            series: [
                {
                    name: '响应量分析',
                    type: 'pie',
                    radius: ['50%', '80%'],
                    avoidLabelOverlap: false,
                    label: {
                        show: false,
                        position: 'center'
                    },
                    labelLine: {
                        show: false
                    },
                    data: data,
                }
            ]
        });
        return (
            <React.Fragment>
                <Drawer
                    ref={(e) => { this.wrapper = e }}
                    title="交互详情"
                    headerStyle={{ height: 48 }}
                    mask={false}
                    onClose={() => { this.props.actions.setState({ key: "showDetail", value: false }) }}
                    visible={showDetail}
                    getContainer={false}
                    width={720}
                    style={{ position: 'absolute' }}
                >
                    <Row type='flex' style={{ height: 220 }}>
                        <Col span={12} style={{ height: '100%' }}>
                            <div id="echarts" style={{ width: '100%', height: '100%' }}></div>
                        </Col>
                        <Col span={12} style={{ height: "100%" }}>
                            <Table columns={columns} dataSource={this.props.detailCountList} size="small" pagination={false} scroll={{ y: 182 }} />
                        </Col>
                    </Row>
                    <div style={{ height: "calc(100% - 245px)", marginTop: 25 }}>
                        <Table columns={columns1} dataSource={this.props.detailListData.data} size="small"
                            loading={this.state.tableListLoading}
                            scroll={{ y: this.props.height - 430 }}
                            pagination={{
                                pageSizeOptions: ['10', '20', '30', '50', "100"],
                                showQuickJumper: true,
                                showSizeChanger: true,
                                current: this.props.detailListParams.pageNum,
                                total: this.props.detailListData.total,
                                pageSize: this.props.detailListParams.pageSize,
                                // 
                                showTotal: () => {
                                    return (<div className='myQmq'>
                                        <Button className="btn1" type="primary" size="small" onClick={this.export}>导出</Button>
                                        共 {this.props.detailListData.total} 条
                                    </div>)
                                },
                                onChange: this.onPageChange,
                                onShowSizeChange: this.onShowSizeChange
                            }} >
                        </Table>
                    </div>
                </Drawer>
                {this.props.taskDetail.show ? (<DetailDrawer
                    id={this.props.taskDetail.rowId}
                    pageType="detail"
                    loading={false}
                    visible={this.props.taskDetail.show}
                    dataSource={this.props.detailDrawerData}
                    onClose={this.closeDetailDrawer}
                    onSaveExtractField={data => {
                        this.saveExtractField(data)
                    }}
                />) : null}
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    ...state.taskManageInteractivePath,
    detailDrawerData: state.taskManageDetail.detailDrawerData,
});

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(actions, dispatch),
        detailActions: bindActionCreators(tDetailActions, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InteractionDetails)